import React, { useState } from "react";
import {
  Box,
  TableRow,
  TableCell,
  Avatar,
  Typography,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Link,
} from "@mui/material";
import { AttachFile, MoreVert } from "@mui/icons-material";
import ChatModal from "../chatModal";

const PastAppointmentRow = ({
  appointment,
  onViewDetail,
  formatDate,
  formatTime,
  getTimeAgo,
}) => {
  const [chatOpen, setChatOpen] = useState(false);
  const [chatUser, setChatUser] = useState(null);

  function openChat(user) {
    setChatUser(user);
    setChatOpen(true);
  }
  function closeChat() {
    setChatOpen(false);
    setChatUser(null);
  }

  return (
    <>
      <TableRow hover>
        {/* 1) Client Name */}
        <TableCell sx={{ borderBottom: "none", py: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              sx={{
                width: 40,
                height: 40,
                bgcolor: "#144a8c",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              {appointment.client?.first_name?.[0]}
              {appointment.client?.last_name?.[0]}
            </Avatar>
            <Box>
              <Typography variant="body1" fontWeight={600} color="#1a1a1a">
                {appointment.client?.first_name} {appointment.client?.last_name}
              </Typography>
            </Box>
          </Box>
        </TableCell>
        {/* 2) Submitted updated */}
        <TableCell sx={{ borderBottom: "none", py: 2 }}>
          <Typography variant="body2" color="#666">
            {appointment.created_at ? getTimeAgo(appointment.created_at) : "N/A"}
          </Typography>
        </TableCell>
        {/* 3) Appointment Time */}
        <TableCell sx={{ borderBottom: "none", py: 2 }}>
          <Box>
            <Typography variant="body1" fontWeight={600} color="#1a1a1a">
              {formatDate
                ? formatDate(appointment.requested_slot?.date)
                : "No Date found"}
            </Typography>
            <Typography variant="body2" color="#666">
              {formatTime
                ? formatTime(appointment.requested_slot?.time)
                : "No Time found"} CST
            </Typography>
          </Box>
        </TableCell>
        {/* 4) Consultation Type */}
        <TableCell sx={{ borderBottom: "none", py: 2 }}>
          <Chip
            label={
              appointment.appointmentType?.appointment_name ||
              "No Appointment Name found"
            }
            sx={{
              bgcolor: "#f5f5f5",
              color: "#333",
              fontWeight: 500,
              fontSize: "14px",
              height: "32px",
            }}
          />
        </TableCell>
        {/* 5) Files */}
        <TableCell sx={{ borderBottom: "none", py: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <AttachFile sx={{ fontSize: 18, color: "#666" }} />
            <Typography variant="body2" color="#666" fontWeight={500}>
              {appointment.documents?.length || 0}
            </Typography>
          </Box>
        </TableCell>
        {/* 6) Action */}
        <TableCell sx={{ borderBottom: "none", py: 2 }}>
          <Button
            variant="contained"
            sx={{
              bgcolor: "#144a8c",
              color: "white",
              textTransform: "none",
              fontWeight: 500,
              px: 2.5,
              py: 0.75,
              "&:hover": {
                bgcolor: "#144a7a",
              },
            }}
            onClick={() => openChat(appointment.client)}
          >
            Chat
          </Button>
          <Button
            variant="outlined"
            sx={{
              borderColor: "#ddd",
              color: "#666",
              textTransform: "none",
              fontWeight: 500,
              px: 2.5,
              py: 0.75,
              ml: 1,
              "&:hover": {
                borderColor: "#bbb",
                bgcolor: "#f9f9f9",
              },
            }}
            onClick={() => onViewDetail && onViewDetail(appointment)}
          >
            View Detail
          </Button>
        </TableCell>
      </TableRow>
      <ChatModal open={chatOpen} onClose={closeChat} clientUser={chatUser} />
    </>
  );
};

export default PastAppointmentRow; 